import { LookupType } from './types';

export const LOOKUP_TYPE_TO_HUMAN_READABLE_NAME: Record<LookupType, string> = {
  [LookupType.ByEmail]: 'Email Address',
  [LookupType.ByUserId]: 'User ID',
};
